



























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import * as pbi from "powerbi-client";
import Axios, { AxiosResponse } from "axios";
import themes from "@/store/modules/themes";
import { Theme } from "@/store/models";
import CodeEditor from "./CodeEditor.vue";

const jsonThemes = [
  {
    name: "Apothecary",
    dataColors: [
      "#93A299",
      "#CF543F",
      "#B5AE53",
      "#848058",
      "#E8B54D",
      "#786C71",
      "#93A2A0",
      "#CF9A3F",
      "#8CB553",
      "#728458",
      "#D0E84D",
      "#786D6C"
    ],
    background: "#FFFFFF",
    foreground: "#CF543F",
    tableAccent: "#93A299"
  },
  {
    name: "Colorblind Safe",
    dataColors: [
      "#074650",
      "#009292",
      "#fe6db6",
      "#feb5da",
      "#480091",
      "#b66dff",
      "#b5dafe",
      "#6db6ff",
      "#914800",
      "#23fd23"
    ],
    background: "#FFFFFF",
    foreground: "#074650",
    tableAccent: "#fe6db6"
  },
  {
    name: "Valentine's Day",
    dataColors: [
      "#990011",
      "#cc1144",
      "#ee7799",
      "#eebbcc",
      "#cc4477",
      "#cc5555",
      "#882222",
      "#A30E33"
    ],
    background: "#FFFFFF",
    foreground: "#ee7799",
    tableAccent: "#990011"
  },
  {
    name: "Waveform",
    dataColors: [
      "#31B6FD",
      "#4584D3",
      "#5BD078",
      "#A5D028",
      "#F5C040",
      "#05E0DB",
      "#3153FD",
      "#4C45D3",
      "#5BD0B0",
      "#54D028",
      "#D0F540",
      "#057BE0"
    ],
    background: "#FFFFFF",
    foreground: "#4584D3",
    tableAccent: "#31B6FD"
  }
];

interface PBIResponse {
  data: RootObject;
}

interface RootObject {
  id: string;
  embedUrl: string;
  type: string;
  embedToken: EmbedToken;
  minutesToExpiration: number;
  defaultPage: string;
  mobileDefaultPage: string;
}

interface EmbedToken {
  token: string;
  tokenId: string;
  expiration: Date;
}

@Component({
  components: {
    CodeEditor
  }
})
export default class MainView extends Vue {
  private fileType: string = "data:text/json;charset=utf-8,";

  private object: Theme;
  private prettyObject;
  public objectConfig: RootObject = {} as RootObject;
  private report: any;

  private staticObject: Theme;

 
  get outputData() {

    const json = JSON.stringify(this.prettyObject, null, 4);
    const blob = new Blob([json], {type: "application/json"});
    const url  = URL.createObjectURL(blob);

    return url;//this.fileType + encodeURIComponent(JSON.stringify(this.prettyObject, null, 4));
  }

  get fileName() {
    return this.prettyObject.name + '.json';
  }

  constructor() {
    super();
    this.object = themes.getTheme;
    this.prettyObject = this.object;
    this.staticObject = Object.assign({}, this.object);
  }

  @Watch("prettyObject", { immediate: false, deep: true })
  private onPersonChanged1(val: Theme) {
    
    if(this.staticObject.name === val.name) {
      this.applyTheme();
      this.staticObject = Object.assign({}, val);
    } else {
      this.staticObject = Object.assign({}, val);
    }
  }

  private applyTheme() {
    // Apply the theme
    const report = this.report;
    report.applyTheme({ themeJson: this.object });
  }

  private mounted() {
    this.getToken();
  }

  private getToken() {
    Axios.request<any>({
      url:
        "https://powerbiplaygroundbe.azurewebsites.net/api/Reports/ThemesReport",
      transformResponse: (r: any) => r
    }).then((response) => {
      this.objectConfig = JSON.parse(response.data) as RootObject;
      this.embedPBI();
    });
  }

  private embedPBI() {
    const config = {
      type: "report",
      tokenType: pbi.models.TokenType.Embed,
      accessToken: this.objectConfig.embedToken.token,
      embedUrl: this.objectConfig.embedUrl,
      id: this.objectConfig.id,
      theme: { themeJson: this.object }
    };

    const powerbi = new pbi.service.Service(
      pbi.factories.hpmFactory,
      pbi.factories.wpmpFactory,
      pbi.factories.routerFactory
    );

    const reportContainer = document.getElementById(
      "embedContainer"
    ) as HTMLElement;
    this.report = powerbi.embed(reportContainer, config);
  }
}
